// This is manually calculated, used for sticky sidebars
export const layoutHeaderDesktopHeightWithSearchBar = 140;
export const layoutHeaderDesktopHeightWithSearchBarAndFilters = 210;

export const IDEALIST_DAYS_PATH = {
  en: '/en/days/get-involved',
  es: '/es/dias/participa',
};
